import { render, staticRenderFns } from "./ErrorText.vue?vue&type=template&id=30586b7b"
import script from "./ErrorText.vue?vue&type=script&lang=js"
export * from "./ErrorText.vue?vue&type=script&lang=js"
import style0 from "./ErrorText.vue?vue&type=style&index=0&id=30586b7b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports